import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class AppUserModel extends Model {
  static reducer(action, AppUserModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.AppUser.schema:
        action.payload.forEach((payload) => {
          const dbData = AppUserModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          AppUserModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
AppUserModel.modelName = "AppUserModel";

AppUserModel.fields = {
  id: attr(),
};

export default AppUserModel;